import React from 'react'
import { Button } from '@mui/material';
import './ending.styles.scss';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

const Ending = ({ text, style }) => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <div className='finally' style={style}>
            <label aria-label={text}>{text}</label>
            <Button aria-label={t("contactUs")} variant="contained" onClick={() => navigate("/contact")} style={{ backgroundColor: '#416D03' }}>{t("contactUs")}</Button>
        </div>
    )
}

export default Ending